import React, { useEffect, useState, useContext } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';

const EditReservationModal = ({ show, handleClose, reservation, handleSave }) => {
    const formatDate = (dateString) => {
        // Suppose le format initial est j-m-année
        const [day, month, year] = dateString.split('-');
        return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
    };

    const [updatedReservation, setUpdatedReservation] = useState({
        ...reservation,
    });

    useEffect(() => {
        if (reservation) {
            setUpdatedReservation({
                ...reservation,
                date: formatDate(reservation.date) || '',
            });
        }
    }, [reservation]);
    

    const handleChange = (e) => {
        const { name, value } = e.target;
        setUpdatedReservation((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleSubmit = () => {
        handleSave(updatedReservation); // Sauvegarde les modifications
        handleClose(); // Ferme le modal
    };

    return (
        <Modal show={show} onHide={handleClose} size="lg">
            <Modal.Header closeButton>
                <Modal.Title>Modifier la réservation</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form>
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-md-6">
                                <Form.Group className="mb-2">
                                    <Form.Label>Date</Form.Label>
                                    <Form.Control
                                        type="date"
                                        name="date"
                                        value={updatedReservation.date || ""}
                                        onChange={handleChange}
                                        required
                                    />
                                </Form.Group>
                                <Form.Group className="mb-2">
                                    <Form.Label>Heure</Form.Label>
                                    <Form.Control
                                        type="time"
                                        name="heure"
                                        value={updatedReservation.heure || ""}
                                        onChange={handleChange}
                                        required
                                    />
                                </Form.Group>
                                <Form.Group className="mb-2">
                                    <Form.Label>Nombre de personnes</Form.Label>
                                    <Form.Control
                                        type="number"
                                        name="nbrPersonne"
                                        value={updatedReservation.nbrPersonne || ""}
                                        onChange={handleChange}
                                        required
                                    />
                                </Form.Group>
                                <Form.Group className="mb-2">
                                    <Form.Label>Nom</Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="nom"
                                        value={updatedReservation.nom || ""}
                                        onChange={handleChange}
                                        required
                                    />
                                </Form.Group>
                                <Form.Group className="mb-2">
                                    <Form.Label>Téléphone</Form.Label>
                                    <Form.Control
                                        type="tel"
                                        name="tele"
                                        value={updatedReservation.tele || ""}
                                        onChange={handleChange}
                                        required
                                    />
                                </Form.Group>
                                <Form.Group className="mb-2">
                                    <Form.Label>E-mail</Form.Label>
                                    <Form.Control
                                        type="email"
                                        name="email"
                                        value={updatedReservation.email || ""}
                                        onChange={handleChange}
                                        required
                                    />
                                </Form.Group>
                            </div>
                            <div className="col-md-6">
                                <Form.Group className="mb-3">
                                    <Form.Label>Réservation pour anniversaire</Form.Label>
                                    <div>
                                        <Form.Check
                                            type="radio"
                                            label="Oui"
                                            name="anniv"
                                            value="oui"
                                            checked={updatedReservation.anniv === 'oui'}
                                            onChange={handleChange}
                                            className="form-check-inline"
                                        />
                                        <Form.Check
                                            type="radio"
                                            label="Non"
                                            name="anniv"
                                            value="non"
                                            checked={updatedReservation.anniv === 'non'}
                                            onChange={handleChange}
                                            className="form-check-inline"
                                        />
                                    </div>
                                </Form.Group>
                                <Form.Group className="mb-2">
                                    <Form.Label>Quel gâteau ?</Form.Label>
                                    <Form.Control
                                        as="select"
                                        name="typeGateau"
                                        value={updatedReservation.typeGateau || ""}
                                        onChange={handleChange}
                                    >
                                        <option value="">Sélectionner un gâteau</option>
                                        <option value="Chocolat(nutella pasta)">
                                            Chocolat(nutella pasta)
                                        </option>
                                        <option value="Fraisier">Fraisier</option>
                                        <option value="personnalise">Personnalisé</option>
                                    </Form.Control>
                                </Form.Group>
                                    {updatedReservation.typeGateau === 'personnalise' && (
                                        <>
                                            <Form.Group className="mb-2">
                                                <Form.Label>Nombre de part au chocolat</Form.Label>
                                                <Form.Control
                                                    type="number"
                                                    name="nbChocolat"
                                                    min='4'
                                                    value={updatedReservation.nbChocolat || ""}
                                                    onChange={handleChange}
                                                    required
                                                />
                                            </Form.Group>
    
                                            <Form.Group className="mb-2">
                                                <Form.Label>Nombre de part à la fraise</Form.Label>
                                                <Form.Control
                                                    type="number"
                                                    name="nbFraises"
                                                    min='4'
                                                    value={updatedReservation.nbFraises || ""}
                                                    onChange={handleChange}
                                                    required
                                                />
                                            </Form.Group>
                                        </>
                                    )}
                                
                                <Form.Group className="mb-2">
                                    <Form.Label>Texte pour personnaliser le gâteau</Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="texteGateau"
                                        value={updatedReservation.texteGateau || ""}
                                        onChange={handleChange}
                                    />
                                </Form.Group>
                                <Form.Group className="mb-2">
                                    <Form.Label>Âge de la personne qui fête son anniversaire</Form.Label>
                                    <Form.Control
                                        type="number"
                                        name="ageP"
                                        value={updatedReservation.ageP || ""}
                                        onChange={handleChange}
                                    />
                                </Form.Group>
                                <Form.Group className="mb-2">
                                    <Form.Label>Prestation par personne/€</Form.Label>
                                    <Form.Control
                                        type="number"
                                        name="prestation"
                                        value= '5'
                                        onChange={handleChange}
                                    />
                                </Form.Group>
                            </div>
                        </div>
                    </div>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    Annuler
                </Button>
                <Button variant="primary" onClick={handleSubmit}>
                    Sauvegarder
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default EditReservationModal;
